import React from "react";
import { withApollo, Query } from "react-apollo";
import styled, { withTheme } from "styled-components/native";
import { MenuButton, Logo } from "cci-component";

import UserInfo from "./UserInfo";
import GetMainMenuInfoQuery from "../query/GetMainMenuInfoQuery";

/* View used to calculate the width of the screen */
const Line = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0;
`;

/* Positions the logo on the top left logo */
const TopLeftLogo = styled(Logo)`
  position: absolute;
  z-index: 100;
  top: ${props => props.theme.pagePadding}px;
  left: ${props => props.theme.pagePadding}px;
`;

/* Positions a component on the top right corner of the screen */
const TopRightWrapper = styled.View`
  position: absolute;
  z-index: 100;
  top: ${props => props.theme.pagePadding}px;
  right: ${props => props.theme.pagePadding}px;
  flex-direction: row;
  align-items: center;
`;

/* Positions a component to the right of the menu section on the left */
const MenuWrapper = styled.View`
  position: absolute;
  z-index: 100;
  top: ${props => props.theme.pagePadding}px;
  left: ${({ theme }) => theme.sidebarWidth - theme.pagePadding - 30}px;
`;

class Header extends React.PureComponent {
  constructor() {
    super();

    this.state = { isNarrow: false };
    this.onLayout = this.onLayout.bind(this);
  }

  onLayout(e) {
    // 768 is the lg breakpoint in react-native-responsive-layout
    this.setState({ isNarrow: e.nativeEvent.layout.width < 768 });
  }

  render() {
    const {
        client,
        data,
        theme,
        onBusinessTap,
        onOfficeTap,
        hideHamburguer,
        hideUserInfo
      } = this.props,
      { isNarrow } = this.state,
      ButtonBlock = isNarrow ? TopRightWrapper : MenuWrapper,
      UserInfoBlock = isNarrow ? null : TopRightWrapper;

    return (
      <React.Fragment>
        {/* Used to calculate the width of the screen */}
        <Line onLayout={this.onLayout} />

        {/* Application logo */}
        <TopLeftLogo source={theme.logoUrl} />

        {/* Hamburger menu to open main menu */}
        {!hideHamburguer && (
          <Query query={GetMainMenuInfoQuery}>
            {({ loading, error, data }) => (
              <ButtonBlock>
                <MenuButton
                  active={data.MainMenu.visible}
                  color={theme.fontColor}
                  onPress={() =>
                    client.writeData({
                      data: {
                        MainMenu: {
                          __typename: "MainMenu",
                          visible: !data.MainMenu.visible
                        }
                      }
                    })
                  }
                />
              </ButtonBlock>
            )}
          </Query>
        )}

        {/* User information section, shown when necessary. */}
        {!hideUserInfo && UserInfoBlock && (
          <UserInfoBlock>
            <UserInfo onBusinessTap={onBusinessTap} onOfficeTap={onOfficeTap} />
          </UserInfoBlock>
        )}
      </React.Fragment>
    );
  }
}

export default withApollo(withTheme(Header));
